const getArticles = (data) => ({
  method: "GET",
  url: "/articles",
  data,
});

export const articlesApi = {
  getArticles,
};
